import axios from '@/libs/api.request'

/**
 * 导出车辆报告
 */
export const exportExport = (data) => {
    return axios.request({
        url: '/api/admin/carreport/export',
        data,
        method: 'post'
    })
}

export const getCarReportInfo = (id, month) => {
    let data = {
        'id': id,
        'month': month
    }
    return axios.request({
        url: '/api/admin/carreport/info',
        data,
        method: 'post'
    })
}

/**
 * 特斯拉工具箱接口
 */
export const toolsAction = (action_type, email, car_id) => {
    let data = {
        'action_type': action_type,
        'email': email,
        'car_id': car_id
    }
    return axios.request({
        url: '/api/admin/tools/action',
        data,
        method: 'post'
    })
}

/**
 * 导出重量
 */
export const exportWeight = (data) => {
    return axios.request({
        url: '/api/admin/weightdata/export',
        data,
        method: 'post'
    })
}